// extracted by mini-css-extract-plugin
module.exports = {"type-pill":"TypePill_type-pill__05a9i","type-pill__background":"TypePill_type-pill__background__V2Aah","copy":"TypePill_copy__0efgG"};